/* eslint no-new: "off" */

import $ from "jquery";

class ParticipantAutoFill {
  /**
   * contains js classes and type of fields
   * @type {array}
   */
  mapping = [
    "select.js-salutation",
    "input.js-title",
    "input.js-first-name",
    "input.js-last-name",
    "input.js-division",
    "select.js-department",
    "input.js-phone",
    "input.js-email",
  ];

  /**
   * html checkbox to handle auto fill
   * @type {*|jQuery|HTMLElement}
   */
  autoFillCheckbox = $(".js-sender-is-participant");

  /**
   * html first participant filed set
   * @type {object}
   */
  affectedRegistrationDom = $(".js-required-registration");

  /**
   * html source filed set
   * @type {object}
   */
  sourceDom = $(".js-basic-fields");

  /**
   * participantAutoFill constructor
   * @constructor
   */
  constructor() {
    this.observeAutoFillCheckbox();
  }

  /**
   * value handling of specified form fields
   */
  observeAutoFillCheckbox() {
    this.autoFillCheckbox.change((e) => {
      if (e.currentTarget.checked) {
        this.cleanFields();
        this.copyFormValues();
      } else {
        this.cleanFields();
      }
    });
  }

  /**
   * clean form field values
   */
  cleanFields() {
    $.each(this.mapping, (index, value) => {
      this.affectedRegistrationDom.find(value).val("");
    });
  }

  /**
   * copy form field values
   */
  copyFormValues() {
    $.each(this.mapping, (index, value) => {
      const currentFieldValue = this.sourceDom.find(value).val();
      this.affectedRegistrationDom.find(value).val(currentFieldValue);
    });
  }
}

(() => {
  if ($(".js-required-registration").length) {
    new ParticipantAutoFill();
  }
})();
